import * as t from "react";
const a = (e) => /* @__PURE__ */ t.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...e }, /* @__PURE__ */ t.createElement("path", { d: "M26.667 48h10.666v-5.333H26.667zM8 16v5.333h48V16zm8 18.667h32v-5.334H16z" }));
export {
  a as default
};
